// src/app/modules/Visitors/pages/visitors-table/column-formatters/VisitStatsFormatter.jsx
import React from "react";
import { TrendingUp, Building2 } from 'lucide-react';

export function VisitStatsFormatter(cellContent, row) {
  const { visit_statistics } = row;

  if (!visit_statistics) {
    return <span className="sety-tbl-sub">—</span>;
  }

  return (
    <div>
      <div style={{ fontWeight: 600, fontSize: 13.5, display: 'flex', alignItems: 'center', gap: 5 }}>
        <TrendingUp size={13} color="var(--purple-500)" />
        {visit_statistics.total_visits} visits
      </div>
      <div className="sety-tbl-sub" style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <Building2 size={12} />{visit_statistics.unique_organizations} locations
      </div>
    </div>
  );
}
